import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Check, MessageCircle } from 'lucide-react'

export const ModalitiesSection = () => {
  const whatsappUrl =
    'https://wa.me/5511963087549?text=Quero%20saber%20mais%20sobre%20o%20SuperFut%20Kids'

  return (
    <section id="modalities" className="py-20 bg-slate-50">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-super-text mb-4">
            Nossas Modalidades
          </h2>
          <p className="text-muted-foreground">
            Opções flexíveis para atender as necessidades da sua família.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Card 1 */}
          <Card className="flex flex-col border-2 border-transparent hover:border-super-blue transition-all duration-300 shadow-lg">
            <CardHeader className="bg-super-blue/10 rounded-t-lg pb-8 pt-8">
              <h3 className="text-2xl font-bold text-super-blue text-center">
                Aulas em Grupo
              </h3>
            </CardHeader>
            <CardContent className="flex-1 pt-8 px-8">
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <Check className="h-5 w-5 text-super-green mt-0.5 shrink-0" />
                  <span className="text-slate-700">
                    Interação, socialização e dinâmica de time
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="h-5 w-5 text-super-green mt-0.5 shrink-0" />
                  <span className="text-slate-700">
                    Turmas pequenas por faixa etária
                  </span>
                </li>
              </ul>
            </CardContent>
            <CardFooter className="p-8 pt-0">
              <Button
                className="w-full bg-super-blue hover:bg-sky-600 text-white font-bold rounded-full py-6"
                asChild
              >
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Tenho interesse
                </a>
              </Button>
            </CardFooter>
          </Card>

          {/* Card 2 */}
          <Card className="flex flex-col border-2 border-transparent hover:border-super-green transition-all duration-300 shadow-lg">
            <CardHeader className="bg-super-green/10 rounded-t-lg pb-8 pt-8">
              <h3 className="text-2xl font-bold text-super-green text-center">
                Aulas Individuais
              </h3>
            </CardHeader>
            <CardContent className="flex-1 pt-8 px-8">
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <Check className="h-5 w-5 text-super-green mt-0.5 shrink-0" />
                  <span className="text-slate-700">
                    Atenção total e evolução personalizada
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="h-5 w-5 text-super-green mt-0.5 shrink-0" />
                  <span className="text-slate-700">
                    Ideal para objetivos específicos e ritmo próprio
                  </span>
                </li>
              </ul>
            </CardContent>
            <CardFooter className="p-8 pt-0">
              <Button
                className="w-full bg-super-green hover:bg-green-600 text-white font-bold rounded-full py-6"
                asChild
              >
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Tenho interesse
                </a>
              </Button>
            </CardFooter>
          </Card>
        </div>

        <div className="text-center mt-8">
          <p className="inline-block bg-white px-6 py-3 rounded-full text-base font-medium text-slate-700 shadow-md border border-slate-200">
            Idade atendida: 2-7 anos
          </p>
        </div>
      </div>
    </section>
  )
}
